module.exports = __webpack_public_path__ + "img/sjk.30d1c09c.jpg";